import { isActingGroup } from '../../etc/is-acting-group';
import { FormConfig, FormLayout } from '../../types';

export function hasSomeGroups(id: keyof FormLayout, formConfig: FormConfig) {
	const { layout } = formConfig;
	const { childIds } = layout[id];
	return childIds?.some(childId => isActingGroup(childId, formConfig)) || false;
}
